<template>
    <div>
        <v-btn small @click="goToShow"><v-icon> mdi-eye </v-icon></v-btn>
        <v-btn small @click="goToEdit"><v-icon> mdi-pencil </v-icon></v-btn>
        <v-btn small @click="deleteRow"><v-icon> mdi-delete </v-icon></v-btn>
    </div>
</template>

<script>
export default {
    methods: {
        deleteRow() {
            // TODO decide how does this entrypoint gets here.
            // maybe through data.params ? (that is auto injected y ag-grid) think not...
            // window?
            // eventListener to change localcomponent state?
            // firing an event, that is handled outside ag-grid's scope
            this.$jmp.bff(this, 'FormBread@delete', this.params.data)
                .then(r => this.params.api.serverSideRowModel.datasource.refresh())
        },
        goToShow() {
            this.$jmp.bff(this, 'FormBread@goToShow', this.params.data)
        },
        goToEdit() {
            this.$jmp.bff(this, 'FormBread@goToEdit', this.params.data)
        },
    },
}
</script>
